/* global EmblaCarousel */

const CompactUsp = (function CompactUspModule() {
  const MOBILE_BREAKPOINT = 768;
  const AUTOPLAY_DELAY = 2000;

  let section;
  let viewport;
  let emblaApi;
  let autoplayTimer;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(() => {
      if (emblaApi) emblaApi.scrollNext();
    }, AUTOPLAY_DELAY);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  function initEmbla() {
    if (!viewport || typeof EmblaCarousel === "undefined") return;
    if (emblaApi) return;

    emblaApi = EmblaCarousel(viewport, {
      loop: true,
      align: "center",
      watchDrag: true,
      duration: 30,
    });

    emblaApi.on("pointerDown", stopAutoplay);
    emblaApi.on("pointerUp", startAutoplay);

    startAutoplay();
  }

  function destroyEmbla() {
    stopAutoplay();
    if (emblaApi) {
      emblaApi.destroy();
      emblaApi = null;
    }
  }

  function handleResize() {
    if (isMobile()) {
      initEmbla();
    } else {
      destroyEmbla();
    }
  }

  function cacheDOM() {
    section = document.querySelector("[data-compact-usp]");
    if (!section) return false;

    viewport = section.querySelector("[data-compact-usp-viewport]");
    return !!viewport;
  }

  return {
    init() {
      if (!cacheDOM()) return;
      handleResize();
      window.addEventListener("resize", handleResize);
    },
    destroy() {
      destroyEmbla();
      window.removeEventListener("resize", handleResize);
    },
  };
})();

document.addEventListener("DOMContentLoaded", CompactUsp.init);
